import angular from 'angular';
import controller from './import-mapping-result-dialog.controller';
import template from './import-mapping-result-dialog.html';

const library = require('@safe-systems/ss-ui-components');

const { ssDialogService } = library;

export class dialogService {
  getOptions({
    customerId = -1, importSetData = {}, importSet = null, title = ''
  }) {
    return {
      controller,
      controllerAs: 'importMappingResultDialogVM',
      locals: {
        customerId,
        importSetData,
        importSet,
        title
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      template,
    };
  }
}

export default angular.module('app.components.global.importMappingResultDialog', [
  ssDialogService
])
  .service('importMappingResultDialog', dialogService)
  .name;

console.log('app.components.global.importDocument.importMappingResultDialog created');
